import React, {CSSProperties, useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import ColumnHeaderMenu from './column-header-menu';
import {useDispatch} from 'react-redux';
import {editBoardColumn, deleteBoardColumn, isNewColumnId} from './../../actions/column.actions';
import {ColumnHeaderProps} from './../../types/board.types';
import ColumnDeleteDialog from './../../modals/column-delete-dialog';
import AutomationModal from './../../modals/automation';
import BoardConst from '../../utils/constants/board';
import {useOnClickOutside} from '../../../hooks/useOnClickOutside';
import BoardService from '../../services/board.service';

const boardService = new BoardService();

const ColumnHeader = (props: ColumnHeaderProps) => {
    const { t } = useTranslation();
    const column = props.column;
    const boardType = props.boardType;
    const cardType = props.cardType;
    const boardDetails = props.boardDetails;
    const isNewCol: boolean = isNewColumnId(column.id);
    const {is_co_manager, is_manager, is_team_admin } = props.wsPermission || {};
    const {editBoard} = props.userPermission;
    const isAdminPermission: boolean = (is_co_manager || is_manager || is_team_admin || editBoard == '1');
    const [editBox, setEditBox] = useState<boolean>(isNewCol);
    const [openDeletePopup, setOpenDeletePopup] = useState<boolean>(false);
    const [openAutlomationDialog, setOpenAutomationDialog] = useState<boolean>(false);
    const columnTitle = column.title || column.c_name;
    const [text, setText] = useState<string>(columnTitle);
    const [automationData, setAutomationData] = useState<any>();
    const dispatch = useDispatch();

    const [inputRef] = useOnClickOutside(() => {
        doPostColumn();
    });

    const doPostColumn = () => {
        if (text) {
            setEditBox(false);
            dispatch(editBoardColumn(column.id, {...column, title: text, c_name: text}));
        }
        else {
            if ((text == null  || text == '')) {
                setText(column.title);
                setEditBox(isNewCol);
            }
        }
    }

    const saveColumn = (e: any) => {
        let isBlurEvent = (e.type == 'blur') ? true : false;
        let isValidCmd = ((e.keyCode == 13 && e.shiftKey == false) || isBlurEvent);
        if (isValidCmd) {
            doPostColumn();
            setTimeout(()=>{
                $(".ui-tooltip").remove();
            },100)
        }
    }

    const onSetText = (e: any) => {
        setEditBox(true); 
    }

    const openDeleteDialog = () => {
        console.log('openDeleteDialog');
        setOpenDeletePopup(true);
    }

    const closeDeleteDialog = () => {
        setOpenDeletePopup(false);
    }

    const deleteColumn = () => {
        setOpenDeletePopup(false);
        dispatch(deleteBoardColumn(column.id));
    }

    const openAutomationPopup = async() => {
        const contentId = document.getElementById('content');
        let type = '';
        if (cardType == BoardConst.BOARD_DATATYPE_ACTIONS)
        {
            type = 'activity';
        }
        else if (cardType == BoardConst.BOARD_DATATYPE_WORKSTREAMS) {
            type = 'workstream';
        }
        else if (cardType == BoardConst.BOARD_DATATYPE_PEOPLE) {
            type = 'people';
        }
        if (type) {
            showLoaderWidget(contentId);
            const params = {columnId: column.id, type};
            const response = await boardService.getAutomationData(params);
            setAutomationData(response.data.response || {});
            setOpenAutomationDialog(true);
            removeLoader();
        }
    }

    const closeAutomationPopup = () => {
        setOpenAutomationDialog(false);
    }

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [editBox]);

    
    let headerStyle:CSSProperties = {};
    let titleStyle:CSSProperties = {};
    let countStyle:CSSProperties = {};
    let columnHeaderClass = '';
    if (boardType == BoardConst.WS_BOARD_TYPE_PROGRESS) {
        columnHeaderClass = 'column-header-standard';
        titleStyle.paddingLeft = '30px';
        titleStyle.cursor = 'default';
        countStyle.paddingRight = '5px';
    }
    else {
        headerStyle.backgroundColor = column.color || '#90A4AE';
    }
    if (boardType != BoardConst.WS_BOARD_TYPE_PROGRESS && isAdminPermission) {
        titleStyle.cursor = 'pointer';
        if (isNewCol) {
            countStyle.paddingRight = '5px';
        }
    }
    else {
        countStyle.paddingRight = '5px';
    }

    if(props.isDragging){
        headerStyle.position = "absolute";
    }else{
        headerStyle.position = "sticky";
    }
    countStyle.marginRight = (!(boardType == BoardConst.WS_BOARD_TYPE_CUSTOM && !isNewCol && isAdminPermission) && !column.isAutomationExist) ? '5px' : '';
    return (
        <>
        <div className={'column-header ' + columnHeaderClass} style={headerStyle} data-column-id={column.id} {...props.dragHandleProps}>
            <div className='column-header-title'>
                { !editBox && <div className='column-title-text truncateText' 
                title={(boardType == BoardConst.WS_BOARD_TYPE_PROGRESS) ? columnTitle : text}
                style={titleStyle} onClick={e => ((boardType != BoardConst.WS_BOARD_TYPE_PROGRESS && isAdminPermission) ? onSetText(e) : false)}>
                    {(boardType == BoardConst.WS_BOARD_TYPE_PROGRESS) ? columnTitle : text}
                    </div> 
                }
                { editBox && isAdminPermission && <input type='text'
                    ref={inputRef}
                    onChange={(e) => setText(e.target.value)}
                    onBlur={e => saveColumn(e)}
                    onKeyDown={ e => saveColumn(e)}
                    value={text} 
                    placeholder={t("Column Name")} /> } 
            </div>
            <div className='column-header-menu'>
                <div className='column-menu-count' style={countStyle}>{props.count}</div>
                {
                    column.isAutomationExist ? <div className='board-automation-white-icon'
                    style = {!(boardType == BoardConst.WS_BOARD_TYPE_CUSTOM && !isNewCol && isAdminPermission ) ? {"marginRight": '5px'}: {}}></div> : ''
                }
                {
                    (boardType == BoardConst.WS_BOARD_TYPE_CUSTOM && !isNewCol && isAdminPermission ) ?
                    <div className='column-menu-hamburg'>
                        <ColumnHeaderMenu columnType={cardType} onDelete={openDeleteDialog} onAutomation={openAutomationPopup} />
                    </div>
                    : ''
                }
            </div>
        </div>
        { boardType == BoardConst.WS_BOARD_TYPE_CUSTOM && openDeletePopup && <ColumnDeleteDialog 
                onClose={closeDeleteDialog}
                onYes={deleteColumn}
                /> }
        { boardType == BoardConst.WS_BOARD_TYPE_CUSTOM && openAutlomationDialog && <AutomationModal
                columnId={column.id}
                data={automationData}
                columnType={cardType}
                onClose={closeAutomationPopup}
                boardDetails={boardDetails}
                dispatch={dispatch}
                /> }
        </>
    )
}

export default ColumnHeader;